import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

// third party modules
import {ScrollToModule} from '@nicky-lenaers/ngx-scroll-to';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

// app modules
import {SharedModule} from '../shared/shared.module';

// Routes
import {SITE_PAGES_ROUTES} from './sitepages.routes';

// Components
import {HomeComponent} from './home/home.component';
import {AboutComponent} from './about/about.component';
import {CookiestermsComponent} from './cookiesterms/cookiesterms.component';
import {LegaltermsComponent} from './legalterms/legalterms.component';
import {PrivacytermsComponent} from './privacyterms/privacyterms.component';
import {FaqComponent} from './faq/faq.component';
import {TermsconditionsComponent} from "./termsconditions/termsconditions.component";
import {CommonModule} from '@angular/common';

/**
 * Site Pages Module
 */
@NgModule({
    declarations: [
        HomeComponent,
        AboutComponent,
        CookiestermsComponent,
        LegaltermsComponent,
        PrivacytermsComponent,
        FaqComponent,
        TermsconditionsComponent
    ],
    exports: [],
    imports: [
        SharedModule,
        SITE_PAGES_ROUTES,
        FormsModule,
        TranslateModule,
        NgbModule,
        ScrollToModule.forRoot(),
        CommonModule
    ]
})
export class SitePagesModule {
}
